// @utilities
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');

const requestTranslationsStart = platform => ({
    type: actionTypes.TRANSLATIONS_FETCH_REQUEST,
    platform,
});

const requestTranslationsSuccess = (platform, translations) => ({
    type: actionTypes.TRANSLATIONS_REQUEST_SUCCESS,
    payload: {
        platform,
        translations,
    },
});

const requestTranslationsFailure = platform => ({
    type: actionTypes.TRANSLATIONS_REQUEST_FAILURE,
    platform,
});

// Request of texts of the webapp (JSON)
const requestTranslations = (platform, language) => (dispatch, getState) => {
    // Continue if the translations have not yet been requested
    const isFetchingFlag = `isFetching${platform}`;
    const isAlreadyFetching = getState().translations.get(isFetchingFlag);

    if (!isAlreadyFetching) {
        // We start searching for the language strings
        dispatch(requestTranslationsStart(platform));
        // Request of the source URL for translations
        APIGet({
            dispatch,
            endpoint: 'getTranslationsURL',
            params: {
                platform,
                language,
            },
        })
            .then(response => {
                if (response.url) {
                    return response.url;
                } else {
                    throw response;
                }
            })
            // Request of translations with received url
            .then(response => APIGet(dispatch, response))
            .then(
                response => {
                    // Received translations
                    const translations = {
                        [language]: JSON.parse(response.text),
                    };
                    // Update translations reducer with reponse
                    dispatch(
                        requestTranslationsSuccess(platform, translations),
                    );
                },
                response => {
                    if (!!response.error) {
                        dispatch(requestTranslationsFailure(platform));
                    } else {
                        throw response;
                    }
                },
            )
            .catch(dispatch(requestTranslationsFailure(platform)));
    }
};

module.exports = {
    requestTranslations,
    requestTranslationsSuccess,
    requestTranslationsFailure,
};
